import { TradKeys } from '@data/trads';
import { ReactElement } from 'react';

type Link = {
  link?: string;
  label?: ReactElement | TradKeys;
  checkStartsWith?: boolean;
};

export const NAV_LINKS_COMMON: Link[] = [
  {
    link: '/locations/paris',
    label: 'nav.locations.paris',
    checkStartsWith: true,
  },
  {
    link: '/locations/europe',
    label: 'nav.locations.europe',
    checkStartsWith: true,
  },
  {
    link: '/locations/asia',
    label: 'nav.locations.asia',
    checkStartsWith: true,
  },
  { link: '/series', label: 'nav.series', checkStartsWith: true },
];

export const NAV_LINKS: Link[] = [
  {
    link: '/',
    label: (
      <span className="text-accent">
        Marc
        <br />
        Malignan
      </span>
    ),
  },
  {},
  ...NAV_LINKS_COMMON,
];

export const MOBILE_NAV_LINKS: Link[] = [
  { link: '/', label: 'nav.home' },
  ...NAV_LINKS_COMMON,
];

export const getNavIndex = (links: Link[], pathname: string) =>
  links.findIndex(({ checkStartsWith, link }) =>
    checkStartsWith ? pathname.startsWith(link) : pathname === link
  );
